import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  wrap: {
    '& h4': {
      userSelect: 'none',
    },
  },
  test: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  answers: {
    width: 300,
    '& svg': {
      color: 'green',
    },
  },
  no: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: theme.palette.primary.main,
    fontSize: '1.25em',
    color: '#fff',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
    userSelect: 'none',
  },
  buttons: {
    '& button': {
      margin: theme.spacing(1),
    },
  },
  text: {
    width: 300,
    margin: theme.spacing(1),
  },
}));

function TestABC (props) {
  const classes = useStyles();
  const { q, a, setAnswer } = props;

  const checkIncorrect = () => {
    if (!a || a === 'sentence-ok') {
      setAnswer('');
    }
  }

  const isCorrect = a === 'sentence-ok';
  const isIncorrect = a !== undefined && a !== null && a !== 'sentence-ok';
  const disabled = a === 'sentence-ok' || a === undefined;

  return (
    <div className={classes.wrap}>
      <div className={classes.test}>
        <h4>{q.sentence}</h4>
        <List className={classes.answers}>
          <ListItem dense button onClick={() => setAnswer('sentence-ok')}>
            <ListItemIcon>
              <Checkbox checked={isCorrect} />
            </ListItemIcon>
            <ListItemText primary="Zdanie poprawne" />
          </ListItem>
          <ListItem dense button onClick={checkIncorrect}>
            <ListItemIcon>
              <Checkbox checked={isIncorrect} />
            </ListItemIcon>
            <ListItemText primary="Zdanie błędne" />
          </ListItem>
        </List>
        <TextField
          variant="outlined"
          label={disabled ? '' : 'brakujące lub zbędne słowo'}
          value={!disabled && a ? a : ''}
          onChange={ev => setAnswer(ev.target.value)}
          className={classes.text}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

export default TestABC;
